import { render, staticRenderFns } from "./TestMailAddresses.vue?vue&type=template&id=57bd23bb&"
import script from "./TestMailAddresses.vue?vue&type=script&lang=js&"
export * from "./TestMailAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports